export default [
    {
        path: "/my",
        name: "my",
        component: () => import("@/views/my/my.vue"),
        meta: {
            title: '个人中心'
        },
    },
    {
        path: "/my/myProfile",
        name: "/my/myProfile",
        component: () => import("@/views/my/views/myProfile.vue"),
        meta: {
            title: '我的档案'
        },
    },
    {
        path: "/my/profileEdit",
        name: "/my/profileEdit",
        component: () => import("@/views/my/views/profileEdit.vue"),
        meta: {
            title: '编辑档案'
        },
    },

    {
        path: "/my/myLearning",
        name: "/my/myLearning",
        component: () => import("@/views/my/views/myLearning.vue"),
        meta: {
            title: '我的学习'
        },
    },
    {
        path: "/my/myTask",
        name: "/my/myTask",
        component: () => import("@/views/my/views/myTask.vue"),
        meta: {
            title: '我的任务'
        },
    },
    {
        path: "/my/myMedal",
        name: "/my/myMedal",
        component: () => import("@/views/my/views/myMedal.vue"),
        meta: {
            title: '我的勋章'
        },
    },
    {
        path: "/my/myAbout",
        name: "/my/myAbout",
        component: () => import("@/views/my/views/myAbout.vue"),
        meta: {
            title: '我的行动'
        },
    },

]
